import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Actions } from './toolbar/toolbar.model';
import { QueryAreaComponent } from './query-area/query-area.component';
import { NgxQueryEditorAbstractService } from './ngx-query-editor.abstract.service';
import { Observable } from 'rxjs';
import { QueryObject, QueryResult, SqlServerModel } from './ngx-query-editor.models';
import { DbExplorerComponent } from './db-explorer/db-explorer.component';

@Component({
  selector: 'lib-ngx-query-editor',
  templateUrl: './ngx-query-editor.component.html',
  styleUrls: ['./ngx-query-editor.component.scss']
})
export class NgxQueryEditorComponent implements OnInit {

  public result: any[] = [];
  public query: QueryObject = {
    database: '',
    queryBody: ''
  };
  public queryResult: QueryResult = {
    result: [],
    schema: []
  };
  public serverSchema$: Observable<any[]>;
  public serverModel$: Observable<SqlServerModel>;

  @Input()
  sqlServerId: string;


  @ViewChild('queryarea') queryArea: QueryAreaComponent;
  @ViewChild('dbexplorer') dbExplorer: DbExplorerComponent;

  constructor(private queryEditorService: NgxQueryEditorAbstractService) {}

  ngOnInit() {
    this.serverModel$ = this.queryEditorService.getSqlServerById(this.sqlServerId);
    this.serverSchema$ = this.queryEditorService.getCollectionSchema('databases', null);
  }

  handleAction($event) {
    if ($event === Actions.Execute) {
      this.execute();
    }
  }

  onNewQueryTab(dbName: string) {
    this.queryArea.addTab(dbName);
  }

  onStateEmitter(state: boolean) {
    this.queryArea.setEmptyState(state);
  }

  execute() {
    const code = this.queryArea.getCode();
    this.query.database = this.queryArea.selectedDbName;
    this.query.queryBody = code;
    if (code) {
      this.queryEditorService.executeQuery(this.query).subscribe(result => this.queryResult = result );
    } else {
      alert('No code to execute ');
    }
  }
}
